import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import SuitCaseIcon from 'shared/images/clock_image.png'
import { Button } from 'shared/ui/button'

import styles from './styles.module.scss'

interface Props {
  onClick?: () => void
}

export const PopUpPurchase: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation()

  const btnStyle = {
    borderRadius: '16px',
    fontWeight: 600,
    fontSize: 17,
  }

  return (
    <div className={styles.container}>
      <img
        src={SuitCaseIcon}
        alt=""
        className={styles.icon}
      />

      <p className={styles.title}>{t('purchase_page.time_over')}</p>
      <p className={styles.titleDesc}>{t('purchase_page.time_over_desc')}</p>

      <div className={styles.buttons}>
        <div className={styles.button}>
          <Button
            style={btnStyle}
            onClick={onClick}
          >
            {t('got')}
          </Button>
        </div>
      </div>
    </div>
  )
}
